<div *ngFor="let row of subs$ | async">
  <span
    *ngIf="getProduct(row.product_id)|async as p">{{p.name}}</span> {{row.quantity}} {{row.price?.getAmountGross()?.toString()}}

</div>
